module.exports = __webpack_public_path__ + "static/img/small-calendar.41990a4b.svg";